/* import __COLOCATED_TEMPLATE__ from './trigger.hbs'; */
import EmberPowerSelectMultipleTrigger from 'ember-power-select/components/power-select-multiple/trigger';

import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import type { BvBtnArgs } from 'volta/components/bv-btn';
import type { ComponentLike, ContentValue, WithBoundArgs } from '@glint/template';

interface BvSelectMultiTriggerSignature {
  Args: Omit<EmberPowerSelectMultipleTrigger['args'], 'Element'> & {
    isRequired?: boolean;
    isLoading?: boolean;
    verticalPosition?: 'auto' | 'above' | 'below';
    size?: BvBtnArgs['size'];
    searchSuffix?: ContentValue;
    selectedPath?: string;
    fill?: boolean;
  };
  Element: HTMLElement;
}

type BvSelectMultiTriggerLike = WithBoundArgs<
  ComponentLike<BvSelectMultiTriggerSignature>,
  'select' | 'searchEnabled' | 'searchField' | 'ariaActiveDescendant' | 'buildSelection'
>;

export default class BvSelectMultiTrigger extends EmberPowerSelectMultipleTrigger {
  @tracked focused = false;

  @action
  deleteOption(option: any) {
    this.args.select?.actions.choose(option);
    return false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvSelectMulti::Trigger': BvSelectMultiTriggerLike;
    'bv-select-multi/trigger': BvSelectMultiTriggerLike;
  }
}
